import { FeatureFlag } from '../FeatureFlag';

export const enableNewsListDebugging = new FeatureFlag({
    key: 'enable-news-list-debugging',
    createdOn: '2025-08-11',
    defaultValue: false,
});
